import React, { Component } from 'react';
import { MDBContainer, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBRow, MDBCol, MDBInput, MDBBtn } from 'mdbreact';
import './this.css';

class CompanyLogin extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
    <MDBModal isOpen={!this.props.isLogin}>
      <MDBModalHeader
        className="text-center blue lighten-1 white-text"
        titleClass="w-100 font-weight-bold"
      >
       会社ログイン　
      </MDBModalHeader>
      <MDBModalBody>
          <form>
            <div className="grey-text">
              <MDBInput
                label="会社ID"
                icon="building"
                group
                type="text"
                validate
                error="wrong"
                success="right"
                required
              />
              <MDBInput
                label="パスワード"
                icon="lock"
                group
                type="password"
                validate
                required
              />
            </div>
          </form>
      </MDBModalBody>
      <MDBModalFooter className="justify-content-center">
        <MDBBtn
          color="info"
          onClick={() => {
          this.props.login();
          }}
        >
          ログイン
        </MDBBtn>
      </MDBModalFooter>
    </MDBModal>
    );
  }
}

export default CompanyLogin;